export const journeyLabels = {
  /*
   * A journey's reminder and late-meeting notifications. Pressure grows through
   * what the reminder says, not how often it comes: before the deadline, on it,
   * and after it, when it names how long ago the last conversation was.
   */
  journey_step_counter: {
    en: 'step {position} of {count}',
    nl: 'stap {position} van {count}',
    fr: 'étape {position} sur {count}',
  },
  journey_deadline_until: {
    en: 'By {date}',
    nl: 'Uiterlijk {date}',
    fr: "D'ici le {date}",
  },
  journey_deadline_passed: {
    en: 'Deadline passed on {date}',
    nl: 'Termijn verstreken op {date}',
    fr: 'Délai dépassé le {date}',
  },
  journey_reminder_before: {
    en: 'Your next conversation with {name} still needs to be planned, ideally before {deadline}.',
    nl: 'Je volgende gesprek met {name} moet nog ingepland worden, graag vóór {deadline}.',
    fr: 'Votre prochaine conversation avec {name} doit encore être planifiée, idéalement avant le {deadline}.',
  },
  journey_reminder_deadline_today: {
    en: 'The deadline for your next conversation with {name} is today. Plan it as soon as possible.',
    nl: 'De termijn voor je volgende gesprek met {name} loopt vandaag af. Plan het zo snel mogelijk in.',
    fr: "Le délai pour votre prochaine conversation avec {name} expire aujourd'hui. Planifiez-la dès que possible.",
  },
  /* `{ago}` is a relative time in the same language: "3 dagen geleden". */
  journey_reminder_deadline_passed: {
    en: 'The deadline for your next conversation with {name} passed {ago}. Plan it as soon as possible.',
    nl: 'De termijn voor je volgende gesprek met {name} is {ago} verstreken. Plan het zo snel mogelijk in.',
    fr: 'Le délai pour votre prochaine conversation avec {name} a expiré {ago}. Planifiez-la dès que possible.',
  },
  journey_reminder_after_previous: {
    en: 'Your last conversation with {name} in this journey was {ago}. Plan the next one as soon as possible.',
    nl: 'Je laatste gesprek met {name} in dit traject was {ago}. Plan het volgende zo snel mogelijk in.',
    fr: 'Votre dernière conversation avec {name} dans ce parcours a eu lieu {ago}. Planifiez la suivante dès que possible.',
  },
  journey_reminder_after_start: {
    en: '{name} started {ago} and you have not had a conversation in this journey yet. Plan it as soon as possible.',
    nl: '{name} is {ago} gestart en jullie hadden nog geen gesprek in dit traject. Plan het zo snel mogelijk in.',
    fr: "{name} a commencé {ago} et vous n'avez pas encore eu de conversation dans ce parcours. Planifiez-la dès que possible.",
  },
  journey_plan_action: {
    en: 'Plan this conversation',
    nl: 'Plan dit gesprek',
    fr: 'Planifier cette conversation',
  },
  /* `{date}` is the day the conversation took place: "woensdag 14 oktober". */
  journey_report_missing_teaser: {
    en: 'Your conversation with {name} on {date} has no report yet. Without a report, this step does not count as done.',
    nl: 'Je gesprek met {name} van {date} heeft nog geen verslag. Zonder verslag telt deze stap niet als afgerond.',
    fr: "Votre conversation avec {name} du {date} n'a pas encore de compte rendu. Sans compte rendu, cette étape ne compte pas comme terminée.",
  },
  journey_write_report_action: {
    en: 'Write the report',
    nl: 'Verslag schrijven',
    fr: 'Rédiger le compte rendu',
  },
  journey_late_status: {
    en: 'Late',
    nl: 'Te laat',
    fr: 'En retard',
  },
  journey_late_teaser: {
    en: 'Your conversation with {name} was moved to {date}, after the deadline of {deadline}.',
    nl: 'Je gesprek met {name} is verzet naar {date}, na de termijn van {deadline}.',
    fr: 'Votre conversation avec {name} a été déplacée au {date}, après le délai du {deadline}.',
  },
  journey_open_action: {
    en: 'Open the journey',
    nl: 'Traject openen',
    fr: 'Ouvrir le parcours',
  },
} as const satisfies Record<string, Record<string, string>>;
